import { render } from "./AppEvents.vue?vue&type=template&id=441c63d0&scoped=true"
import script from "./AppEvents.vue?vue&type=script&lang=js"
export * from "./AppEvents.vue?vue&type=script&lang=js"

import "./AppEvents.vue?vue&type=style&index=0&id=441c63d0&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441c63d0"]])

export default __exports__